module.exports = __webpack_public_path__ + "img/stamp.8a49ce2e.svg";